export default __webpack_public_path__ + "static/848-6429f0a4a1f803cf0195ba208ebcfe3e.gif";